import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { State, City } from "country-state-city";
import {
  utilGetDocumentFilters,
  utilCreateDocumentMenuWithCollections,
  utilCreateDocumentWithIdReferenceData,
  utilUpdateDocument,
  saveImageToFirebaseStorage,
  utilCreateUserWithEmailAndPassword,
} from "../../util/UtilsFirebase";
import { useAuthContext } from "../../hooks/useAuthContext";

import Modal from "react-modal";
import "./Signup.css";

export default function Signup() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [apellidoP, setApellidoP] = useState("");
  const [apellidoM, setApellidoM] = useState("");
  const [email, setEmail] = useState("");
  const [razonSocial, setRazonSocial] = useState("");
  const [rfc, setRfc] = useState("");
  const [direccion, setDireccion] = useState("");
  const [name, setName] = useState("");
  const [telefono, setTelefono] = useState("");
  const [type, setType] = useState("truck");
  const [estado, setEstado] = useState("");
  const [estadoCode, setEstadoCode] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [admin, setAdmin] = useState("");
  const { user, setRegister } = useAuthContext();
  const [trucksAdmin, setTrucksAdmin] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [frontera, setFrontera] = useState(false);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const fullName = userName + " " + apellidoP + " " + apellidoM;
  const customModalStyles = {
    content: {
      width: "600px",
      height: "500px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };

  useEffect(() => {
    setEmail(user.email);
  }, [user]);

  async function getTrucksAdmin(ciuda, typ) {
    if (typ === "truck") {
      const filtros = [
        { campo: "type", operador: "==", valor: "truck-admin" },
        { campo: "ciudad", operador: "==", valor: ciuda },
        { campo: "estado", operador: "==", valor: estado },
        { campo: "valid", operador: "==", valor: true },
      ];

      const result = await utilGetDocumentFilters("registro", filtros);

      setTrucksAdmin(result);
    }
  }

  const handleConfirmModal = async () => {
    const user = await utilCreateUserWithEmailAndPassword(email, fullName);
    if (!user) {
      alert("Ya cuenta con un usuario registrado.");
    }
    const btn = document.getElementById("BtnAceptar");
    btn.disabled = true;
    const btnC = document.getElementById("BtnCancelar");
    btnC.disabled = true;
    let downloadURL = "";

    if (!image) {
      alert("Seleccione una imagen");
      return;
    }

    const references = [
      {
        nameCollection: "users",
        nameField: "user",
        id: user.id,
      },
    ];

    if (type === "truck" && admin !== "" && admin !== "Ninguno") {
      const dataAdmin = {
        nameCollection: "registro",
        nameField: "admin",
        id: admin,
      };

      references.push(dataAdmin);
    }

    const data = {
      email: email,
      razon_social: razonSocial,
      name: name,
      rfc: rfc,
      type: type,
      ciudad: ciudad,
      estado: estado,
      estadoCode: estadoCode,
      phone: telefono,
      paisCode: "MX",
      pais: "Mexico",
      carta: false,
      digital: false,
      efectivo: false,
      tarjeta: false,
      direccion: direccion,
      valid: true,
      frontera: frontera,
      table: "0",
      mensaje: false,
      mesero: false,
      resenia: false,
      promo: false,
      pagar: false,
      menu: false,
      img: "",
      equivalenciapuntos: "1",
      privacyAccepted: true,
    };

    const registro = await utilCreateDocumentWithIdReferenceData(
      "registro",
      data,
      references
    );

    let path = "";

    if (type === "truck") {
      path = "truck/" + registro.id;
    } else if (type === "restaurant") {
      path = "restaurantes/" + registro.id;
    } else {
      path = "truck-admin/" + registro.id;
    }

    downloadURL = await saveImageToFirebaseStorage(path, image);

    if (downloadURL) {
      setImageUrl(downloadURL);
    }

    registro.img = downloadURL;

    utilUpdateDocument("registro", registro.id, registro);
    setRegister(registro);

    const referencesMenu = [
      {
        nameCollection: "registro",
        nameField: "registro",
        id: registro.id,
      },
    ];

    let categoria = [
      {
        name: "Categoria 1",
        img: "",
        active: true,
      },
    ];

    let platillo = [
      {
        available: true,
        costo: 100,
        description: "",
        img: "",
        name: "Platillo 1",
        show: true,
      },
    ];

    await utilCreateDocumentMenuWithCollections(
      { name: "Menu" },
      categoria,
      platillo,
      referencesMenu
    );

    setIsModalOpen(false);
    navigate("/");
  };

  const handleCancelModal = () => {
    // El usuario canceló el envío del formulario
    console.log("Envío del formulario cancelado");
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsModalOpen(true);
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const selectedImage = e.target.files[0];

      // Read the image file and create a preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(selectedImage);
        setImageUrl(reader.result);
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  return (
    <div className="container-fluid">
      <Form onSubmit={handleSubmit} className="auth-form">
        <div className="row">
          <div className="col-sm-12 center-header">
            <h2>¡Gracias por registrarte con nosotros!</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 center-header">
            <h4>
              Completa la informacion requerida para iniciar el servicio de
              Rapdis
            </h4>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-sm-12 center-header">
            <h2>Informacion de tu perfil</h2>
          </div>
        </div>
        <div className="row center-form">
          <div className="col-sm-4">
            <Form.Group controlId="userName">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                required
                type="text"
                onChange={(e) => setUserName(e.target.value)}
                value={userName}
              />
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="userName">
              <Form.Label>Apellido Paterno</Form.Label>
              <Form.Control
                required
                type="text"
                onChange={(e) => setApellidoP(e.target.value)}
                value={apellidoP}
              />
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="userName">
              <Form.Label>Apellido Materno</Form.Label>
              <Form.Control
                required
                type="text"
                onChange={(e) => setApellidoM(e.target.value)}
                value={apellidoM}
              />
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                readOnly
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
            </Form.Group>
            <br />
          </div>

          {/* <div className="col-sm-4">
            <Form.Group controlId="email">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                autoComplete="off"
              />
            </Form.Group>
            <br />
          </div> */}

          {/* <div className="col-sm-4">
            <Form.Group controlId="email">
              <Form.Label>Confirma tu contraseña</Form.Label>
              <Form.Control
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                autoComplete="off"
              />
            </Form.Group>
            <br />
          </div> */}

          <div className="row">
            <div className="col-sm-12 center-header">
              <h2>Informacion de tu negocio</h2>
            </div>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="name">
              <Form.Label>Nombre de Establecimiento</Form.Label>
              <Form.Control
                required
                type="text"
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="razonSocial">
              <Form.Label>Razon Social</Form.Label>
              <Form.Control
                required
                type="text"
                onChange={(e) => setRazonSocial(e.target.value)}
                value={razonSocial}
              />
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="rfc">
              <Form.Label>Telefono</Form.Label>
              <Form.Control
                required
                type="number"
                onChange={(e) => setTelefono(e.target.value)}
                value={telefono}
              />
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="rfc">
              <Form.Label>RFC</Form.Label>
              <Form.Control
                required
                type="text"
                onChange={(e) => setRfc(e.target.value)}
                value={rfc}
              />
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="type">
              <Form.Label>Estado</Form.Label>
              <select
                value={estadoCode}
                onChange={(e) => {
                  setEstadoCode(e.target.value);
                  setEstado(e.target[e.target.selectedIndex].innerText);
                }}
              >
                {State.getStatesOfCountry("MX").map((item, index) => (
                  <option key={index} value={item.isoCode}>
                    {item.name}
                  </option>
                ))}
              </select>
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="type">
              <Form.Label>Ciudad</Form.Label>
              <select
                value={ciudad}
                onChange={(e) => {
                  setCiudad(e.target.value);
                  getTrucksAdmin(e.target.value, type);
                }}
              >
                {City.getCitiesOfState("MX", estadoCode).map((item, index) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>
            </Form.Group>
          </div>

          <div className="col-sm-4">
            <Form.Group controlId="direccion">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                required
                type="text"
                onChange={(e) => setDireccion(e.target.value)}
                value={direccion}
              />
            </Form.Group>
          </div>
          <div className="col-sm-4">
            <Form.Group controlId="type">
              <Form.Label>Tipo de Negocio</Form.Label>
              <select
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                  getTrucksAdmin(ciudad, e.target.value);
                }}
              >
                <option value={"truck-admin"}>Food Park</option>
                <option value={"truck"}>Truck</option>
                <option value={"restaurant"}>Restaurante</option>
              </select>
            </Form.Group>
          </div>

          {type === "truck" ? (
            <div className="col-sm-4">
              <Form.Group controlId="admin">
                <Form.Label>Seleccione Parque</Form.Label>
                <select
                  required
                  value={admin}
                  onChange={(e) => {
                    setAdmin(e.target.value);
                    console.log(e.target.value);
                  }}
                >
                  <option value="Ninguno">Sin asociar</option>
                  {trucksAdmin.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </Form.Group>
            </div>
          ) : (
            <></>
          )}

          {type !== "truck-admin" ? (
            <div className="col-sm-4">
              <Form.Group controlId="type">
                <Form.Label>IVA</Form.Label>
                <select
                  value={frontera}
                  onChange={(e) => {
                    if (e.target.value === "true") {
                      setFrontera(true);
                    } else {
                      setFrontera(false);
                    }
                  }}
                >
                  <option value={true}>8%</option>
                  <option value={false}>16%</option>
                </select>
              </Form.Group>
            </div>
          ) : (
            <></>
          )}
        </div>

        <div className="row center-form"></div>

        <div className="row">
          <div className=" offset-sm-4 col-sm-4 center">
            <Form.Group controlId="img">
              <Form.Label>Logo del negocio</Form.Label>
              <br />
              <label>
                <img
                  id="logo_img"
                  alt=""
                  src={imageUrl}
                  height="92"
                  width="132"
                />
                <input
                  id="logoNeg"
                  type="file"
                  style={{ display: "none" }}
                  accept="image/png, image/jpeg"
                  multiple={false}
                  onChange={handleImageChange}
                />
              </label>
            </Form.Group>
            <label>Click para seleccionar imagen.</label>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className=" offset-sm-4 col-sm-4 center">
            <Button variant="primary" className="button" type="submmit">
              REGISTRAR
            </Button>
          </div>
        </div>
        <Modal
          style={customModalStyles}
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          contentLabel="Confirmación"
        >
          <h2>Aviso de privacidad</h2>
          <p>
            POLÍTICA DE PRIVACIDAD El presente Política de Privacidad establece
            los términos en que Rapdis usa y protege la información que es
            proporcionada por sus usuarios al momento de utilizar su sitio web.
            Esta compañía está comprometida con la seguridad de los datos de sus
            usuarios. Cuando le pedimos llenar los campos de información
            personal con la cual usted pueda ser identificado, lo hacemos
            asegurando que sólo se empleará de acuerdo con los términos de este
            documento. Sin embargo esta Política de Privacidad puede cambiar con
            el tiempo o ser actualizada por lo que le recomendamos y enfatizamos
            revisar continuamente esta página para asegurarse que está de
            acuerdo con dichos cambios. Información que es recogida Nuestro
            sitio web podrá recoger información personal por ejemplo: Nombre,
            información de contacto como su dirección de correo electrónica e
            información demográfica. Así mismo cuando sea necesario podrá ser
            requerida información específica para procesar algún pedido o
            realizar una entrega o facturación. Uso de la información recogida
            Nuestro sitio web emplea la información con el fin de proporcionar
            el mejor servicio posible, particularmente para mantener un registro
            de usuarios, de pedidos en caso que aplique, y mejorar nuestros
            productos y servicios. Es posible que sean enviados correos
            electrónicos periódicamente a través de nuestro sitio con ofertas
            especiales, nuevos productos y otra información publicitaria que
            consideremos relevante para usted o que pueda brindarle algún
            beneficio, estos correos electrónicos serán enviados a la dirección
            que usted proporcione y podrán ser cancelados en cualquier momento.
            Rapdis está altamente comprometido para cumplir con el compromiso de
            mantener su información segura. Usamos los sistemas más avanzados y
            los actualizamos constantemente para asegurarnos que no exista
            ningún acceso no autorizado. Cookies Una cookie se refiere a un
            fichero que es enviado con la finalidad de solicitar permiso para
            almacenarse en su ordenador, al aceptar dicho fichero se crea y la
            cookie sirve entonces para tener información respecto al tráfico
            web, y también facilita las futuras visitas a una web recurrente.
            Otra función que tienen las cookies es que con ellas las web pueden
            reconocerte individualmente y por tanto brindarte el mejor servicio
            personalizado de su web. Nuestro sitio web emplea las cookies para
            poder identificar las páginas que son visitadas y su frecuencia.
            Esta información es empleada únicamente para análisis estadístico y
            después la información se elimina de forma permanente. Usted puede
            eliminar las cookies en cualquier momento desde su ordenador. Sin
            embargo las cookies ayudan a proporcionar un mejor servicio de los
            sitios web, estás no dan acceso a información de su ordenador ni de
            usted, a menos de que usted así lo quiera y la proporcione
            directamente noticias. Usted puede aceptar o negar el uso de
            cookies, sin embargo la mayoría de navegadores aceptan cookies
            automáticamente pues sirve para tener un mejor servicio web. También
            usted puede cambiar la configuración de su ordenador para declinar
            las cookies. Si se declinan es posible que no pueda utilizar algunos
            de nuestros servicios. Enlaces a Terceros Este sitio web pudiera
            contener en laces a otros sitios que pudieran ser de su interés. Una
            vez que usted de clic en estos enlaces y abandone nuestra página, ya
            no tenemos control sobre al sitio al que es redirigido y por lo
            tanto no somos responsables de los términos o privacidad ni de la
            protección de sus datos en esos otros sitios terceros. Dichos sitios
            están sujetos a sus propias políticas de privacidad por lo cual es
            recomendable que los consulte para confirmar que usted está de
            acuerdo con estas. Control de su información personal En cualquier
            momento usted puede restringir la recopilación o el uso de la
            información personal que es proporcionada a nuestro sitio web. Cada
            vez que se le solicite rellenar un formulario, como el de alta de
            usuario, puede marcar o desmarcar la opción de recibir información
            por correo electrónico. En caso de que haya marcado la opción de
            recibir nuestro boletín o publicidad usted puede cancelarla en
            cualquier momento. Esta compañía no venderá, cederá ni distribuirá
            la información personal que es recopilada sin su consentimiento,
            salvo que sea requerido por un juez con un orden judicial. Rapdis Se
            reserva el derecho de cambiar los términos de la presente Política
            de Privacidad en cualquier momento.
          </p>
          <button
            style={{ marginRight: 5 }}
            onClick={handleConfirmModal}
            id="BtnAceptar"
          >
            Aceptar
          </button>
          <button onClick={handleCancelModal} id="BtnCancelar">
            Cancelar
          </button>
        </Modal>
      </Form>
    </div>
  );
}
